module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', {
    staticClass: "mb-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.init()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("\n            mdi-cached\n          ")]), _vm._v(" \n          Reload\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.revMeetingSections), function(revItem, revIdx) {
    return _c('div', {
      key: revIdx
    }, [_c('h3', {
      staticClass: "pa-0 ma-0"
    }, [_vm._v(_vm._s(revItem.title))]), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 mt-3"
    }), _vm._v(" "), _c('v-row', {
      staticClass: "mt-0 mb-1 pb-2 text-right"
    }, [_c('v-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "12",
        "xs": "6",
        "md": "6",
        "justify": "left",
        "align": "left",
        "pt-0": ""
      }
    }), _vm._v(" "), _c('v-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "12",
        "xs": "6",
        "md": "6",
        "justify": "right",
        "align": "right",
        "pt-0": ""
      }
    }, [(revItem.currentMode === 'view') ? _c('v-btn', {
      attrs: {
        "color": "secondary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeModeCustom('edit', revItem)
        }
      }
    }, [_c('v-icon', _vm._g({
      attrs: {
        "small": ""
      }
    }, _vm.on), [_vm._v("edit")]), _vm._v("\n          Edit Mode\n        ")], 1) : _vm._e(), _vm._v(" "), (revItem.currentMode === 'edit') ? _c('v-btn', {
      attrs: {
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeModeCustom('view', revItem)
        }
      }
    }, [_vm._v("\n          Close Edit\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "30px!important"
      }
    }, [_c('v-data-table', {
      staticClass: "review-meeting-table elevation-1",
      attrs: {
        "dense": "",
        "headers": _vm.headers,
        "search": _vm.filter,
        "items": revItem.data,
        "items-per-page": 10
      },
      scopedSlots: _vm._u([{
        key: "item.name",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "300px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")])])])]
        }
      }, {
        key: "item.AM",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "200px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.AM) + "\n              ")])])])]
        }
      }, {
        key: "item.CC",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "200px"
            }
          }, [_c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.CC) + "\n              ")])])])]
        }
      }, {
        key: "item.reviewMeetingDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "min-width": "200px"
            }
          }, [(revItem.currentMode === 'view') ? _c('div', [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                " + _vm._s(item.reviewMeetingDate) + "\n              ")])]) : _vm._e(), _vm._v(" "), (revItem.currentMode === 'edit') ? _c('div', [_c('add-review-meeting-date', {
            attrs: {
              "oldReviewDate": item.reviewMeetingDate,
              "campaignID": item.id,
              "options": {
                theme: 'tableview'
              }
            },
            on: {
              "updated": function($event) {
                var i = arguments.length, argsArray = Array(i);
                while ( i-- ) argsArray[i] = arguments[i];

                return _vm.invokeReviewMeetingUpdated.apply(void 0, [ item ].concat( argsArray ))
              }
            }
          })], 1) : _vm._e()])]
        }
      }, {
        key: "item.sentimentDueDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.sentimentDueDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.sentimentDueDate, item.SentimentDateCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.sentimentDueDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.sentimentDueDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.sentimentDateColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'SentimentDateCol')
              }
            },
            model: {
              value: (item.SentimentDateCol.status),
              callback: function($$v) {
                _vm.$set(item.SentimentDateCol, "status", $$v)
              },
              expression: "item.SentimentDateCol.status"
            }
          })], 1)]), _vm._v(" "), (item.SentimentDateCol.reviewDateURL) ? _c('v-btn', _vm._g(_vm._b({
            staticClass: "btn-view-review-deck",
            attrs: {
              "href": item.SentimentDateCol.reviewDateURL,
              "target": "_blank",
              "color": "secondary",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            staticClass: "mr-0",
            attrs: {
              "x-small": "",
              "left": ""
            }
          }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Review Deck")])], 1) : _vm._e()], 1) : _vm._e()])]
        }
      }, {
        key: "item.ccDeckReadyDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.ccDeckReadyDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.ccDeckReadyDate, item.CCReadyDeckCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.ccDeckReadyDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.ccDeckReadyDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.ccReadyDeckColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'CCReadyDeckCol')
              }
            },
            model: {
              value: (item.CCReadyDeckCol.status),
              callback: function($$v) {
                _vm.$set(item.CCReadyDeckCol, "status", $$v)
              },
              expression: "item.CCReadyDeckCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.amDeckReadyDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.amDeckReadyDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.amDeckReadyDate, item.AMReadyDeckCol.status)) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.amDeckReadyDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.amDeckReadyDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.amReadyDeckColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'AMReadyDeckCol')
              }
            },
            model: {
              value: (item.AMReadyDeckCol.status),
              callback: function($$v) {
                _vm.$set(item.AMReadyDeckCol, "status", $$v)
              },
              expression: "item.AMReadyDeckCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.overallAlignmentDate",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.overallAlignmentDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "right"
            }
          }, [_c('div', {
            staticClass: "col-checkbox-label"
          }, [(_vm.showOverdueLabel(item.overallAlignmentDate, item.overallAlignmentCol.status) && !item.overallAlignmentCol.status) ? _c('v-chip', {
            attrs: {
              "small": "",
              "color": "red",
              "text-color": "white"
            }
          }, [_vm._v("\n                    " + _vm._s(item.overallAlignmentDate) + "\n                  ")]) : _c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    " + _vm._s(item.overallAlignmentDate) + "\n                  ")])], 1), _vm._v(" "), _c('div', [_c('v-checkbox', {
            staticClass: "mt-0",
            attrs: {
              "color": "secondary",
              "value": false,
              "disabled": !_vm.overallAlignmentColAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'overallAlignmentCol')
              }
            },
            model: {
              value: (item.overallAlignmentCol.status),
              callback: function($$v) {
                _vm.$set(item.overallAlignmentCol, "status", $$v)
              },
              expression: "item.overallAlignmentCol.status"
            }
          })], 1)])]) : _vm._e()])]
        }
      }, {
        key: "item.approvedByAdmin",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start date-columns"
          }, [(item.approvedByAdminCol && !_vm.reviewMeetingFilters.showEmptyReviewDate) ? _c('div', [_c('div', {
            staticClass: "d-flex flex-row",
            staticStyle: {
              "justify-content": "center"
            }
          }, [_c('div', [_c('v-checkbox', {
            staticClass: "mt-2",
            attrs: {
              "color": "green",
              "value": false,
              "disabled": !_vm.approvedByAdminAllow,
              "hide-details": ""
            },
            on: {
              "change": function($event) {
                return _vm.changeCheckBox(item, 'approvedByAdminCol')
              }
            },
            model: {
              value: (item.approvedByAdminCol.status),
              callback: function($$v) {
                _vm.$set(item.approvedByAdminCol, "status", $$v)
              },
              expression: "item.approvedByAdminCol.status"
            }
          })], 1), _vm._v(" "), (item.approvedByAdminCol.status) ? _c('div', {
            staticClass: "col-checkbox-label"
          }, [_c('p', {
            staticClass: "text-left mb-0"
          }, [_vm._v("\n                    Review Completed\n                  ")])]) : _vm._e()])]) : _vm._e()])]
        }
      }, {
        key: "item.feedback",
        fn: function(ref) {
          var item = ref.item;

          return [_c('td', {
            staticClass: "text-start",
            staticStyle: {
              "width": "150px"
            }
          }, [_c('div', [(item.feedbackForm) ? _c('v-btn', _vm._g(_vm._b({
            attrs: {
              "to": '/client/feedback-form?id=' + item.feedbackForm.id,
              "target": "_blank",
              "color": "success",
              "small": "",
              "text": ""
            }
          }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
            attrs: {
              "left": ""
            }
          }, [_vm._v("remove_red_eye")]), _vm._v(" "), _c('span', [_vm._v("View Form")])], 1) : _vm._e(), _vm._v(" "), (!item.feedbackForm && item.AM && item.CC) ? _c('v-tooltip', {
            attrs: {
              "right": "",
              "open-on-hover": false
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  attrs: {
                    "color": "secondary",
                    "small": "",
                    "text": ""
                  },
                  on: {
                    "click": function($event) {
                      return _vm.copyFeedbackLink(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "left": ""
                  }
                }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Link")])], 1)]
              }
            }], null, true),
            model: {
              value: (item.linkCopied),
              callback: function($$v) {
                _vm.$set(item, "linkCopied", $$v)
              },
              expression: "item.linkCopied"
            }
          }, [_vm._v(" "), _c('span', [_c('v-icon', {
            attrs: {
              "color": "white darken-2"
            }
          }, [_vm._v("mdi-check-all")]), _vm._v(" Copied")], 1)]) : _vm._e()], 1)])]
        }
      }, {
        key: "no-data",
        fn: function() {
          return [_vm._v("No Data")]
        },
        proxy: true
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.feedbackLink
    }
  }), _vm._v(" "), _c('review-deck-url-modal', {
    attrs: {
      "value": _vm.reviewDeckURLDialog,
      "item": _vm.reviewDeckItem,
      "dateCol": _vm.reviewDateCol
    },
    on: {
      "saveClicked": _vm.saveReviewDeckURL,
      "closeClicked": _vm.closeReviewDeckModal
    },
    model: {
      value: (_vm.reviewDeckURLDialog),
      callback: function($$v) {
        _vm.reviewDeckURLDialog = $$v
      },
      expression: "reviewDeckURLDialog"
    }
  }), _vm._v(" "), _c('review-meeting-checklist-modal', {
    attrs: {
      "value": _vm.checkListsDialog,
      "item": _vm.checkItem,
      "dateCol": _vm.checkCol
    },
    on: {
      "saveClicked": _vm.saveReviewMeetingCheckList,
      "closeClicked": _vm.closeCheckListModal
    },
    model: {
      value: (_vm.checkListsDialog),
      callback: function($$v) {
        _vm.checkListsDialog = $$v
      },
      expression: "checkListsDialog"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1c2f008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReviewMeeting/DataTable.vue
// module id = 2316
// module chunks = 0